/**
 * typescript's `Set#has` doesn't provide strict type checking for string enum values.
 * this wrapper ensures that we can never check for a capability that is not in the enum.
 */
export class StrictSet<T extends string> {
  private set: Set<T>

  constructor(values: Iterable<T>) {
    this.set = new Set(values)
  }

  has(value: T): boolean {
    return this.set.has(value)
  }

  add(value: T): void {
    this.set.add(value)
  }

  delete(value: T): boolean {
    return this.set.delete(value)
  }

  get size(): number {
    return this.set.size
  }

  [Symbol.iterator](): Iterator<T> {
    return this.set[Symbol.iterator]()
  }
}
